
import { useEffect, useState } from "react";
import api from "../../../../../services/api";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import LoadingBackdrop from "../../../../../load/loadingBackdrop";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import RegisterAccess from "../../../../../utils/registerAccess";
import HeaderSession from "../../../../../utils/headerSession";
import ButtonLeft from "../../../../../utils/buttonLeft";
import { Card, Container, DialogActions, Typography } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import ItensFactura from "./itensFactura";
import Loading from "../../../../../load/loading";
import * as yup from 'yup'; // VALIDACAO
import { useDispatch } from "react-redux";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";
import InputDocUpload from "../../../../../utils/inputFileUpload/inputDocUpload";
import GetDoc from "../../../../../utils/getDoc";


export default function FormAddItemImportacao({ title }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [addItem, setAddItem] = useState('');
    const { id } = useParams();
    const [lista, setLista] = useState('');
    const [message, setMessage] = useState('');
    const [messageError, setErrorMessage] = useState('');
    const [solicitacao, setSolicitacao] = useState('');
    const [open, setOpen] = useState(false);


    useEffect(() => {
        api.get(`/solicitacao-importacao/${id}`)
            .then(response => {
                // console.log(response)
                if (response.data.solicitacaoImportacao.status !== 'Aprovado') {
                    setSolicitacao(response.data.solicitacaoImportacao)
                } else {
                    navigate(-1)
                }
            }).catch(err => '')
    }, [id, navigate, message])

    // function handleChange(e) {
    //     e.target.files ?
    //         setAddItem({ ...addItem, [e.target.name]: e.target.files[0] })
    //         :
    //         setAddItem({ ...addItem, [e.target.name]: e.target.value })
    // }

    async function submitAddItem() {
        setOpen(true)
        setErrorMessage('')
        setMessage('')

        api.patch('/solicitacao-importacao/add-item', { ...addItem, solicitacaoImportacaoId: solicitacao?._id })
            .then(res => {
                setMessage(res.data.msg)
                // console.log(res)
                // setAddItem('')
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Item adicionado com sucesso. Pode adicionar mais itens.!' },
                });
                setSolicitacao(res.data.solicitacaoImportacao)
                // window.location.reload()
            }).catch(error => {
                setErrorMessage(error.response.data.message)

                // console.log(error)
            }).finally(() => setOpen(false))
    }

    async function HandleChangeFile(file, name) {
        setLista((lista) => ({ ...lista, [name]: file }))
    }

    async function submiteAddILista() {
        setOpen(true)
        setErrorMessage('')
        setMessage('')

        const formData = new FormData();
        formData.append("file", lista?.listaItems)
        formData.append("solicitacaoImportacaoId", solicitacao?._id)

        api.patch('/solicitacao-importacao/add-lista', formData)
            .then(res => {
                setMessage(res.data.msg)
                // console.log(res)
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Lista adicionada com sucesso. Pode adicionar mais itens.!' },
                });
                setSolicitacao(res.data.solicitacaoImportacao)
                setLista('')

            }).catch(error => {
                setErrorMessage(error.response.data.message)

                // console.log(error)
            }).finally(() => setOpen(false))
    }


    async function validate() {
        setErrorMessage('');

        let schema = yup.object().shape({

            valorKZ: yup.string("Necessário inserir o valor total em kz").required("Necessário inserir o valor total em kz"),
            valorTotal: yup.string("Necessário inserir o valor total de item").required("Necessário inserir o valor total do item"),
            valorUnitario: yup.string("Necessário inserir o valor unitario de item").required("Necessário inserir o valor unitario do item"),
            // pontoEntrada: yup.string("Necessário inserir o ponto de entrada").required("Necessário inserir o ponto de entrada"),
            // emolumentosKZ: yup.string("Necessário inserir o valor do emolumento").required("Necessário inserir o valor do emolumento"),
            dataValidade: yup.string("Necessário inserir a data de validade").required("Necessário inserir a data validade"),
            dataEmissao: yup.string("Necessário inserir a data de emissão").required("Necessário inserir a data de emissão"),
            teorBaseG: yup.string("Necessário inserir o teor base (G)").required("Necessário inserir o teor base (G)"),
            quantidade: yup.string("Necessário inserir a quantidade").required("Necessário inserir a quantidade"),
            formaFarmaceutica: yup.string("Necessário inserir a forma farmaceutica").required("Necessário inserir a forma farmaceutica"),
        })

        try {
            await schema.validate(addItem);
            submitAddItem();
        } catch (error) {
            setErrorMessage(error.errors);
        }
        return false
    }

    return (
        <div>
            <RegisterAccess page={'adicionar itens na solicitação de importação'} />
            <LoadingBackdrop open={open} text={'Adicionando itens na solicitaçao.!'} />

            <Container >
                <HeaderSession title={title} />
                {message && <MessageSuccess message={message} />}
                {messageError && < MessageError message={messageError} />}

                {solicitacao ?
                    <div>
                        <Card style={{ padding: 10, marginTop: 50 }}>

                            <div style={{ maxWidth: 530, margin: 'auto' }}>

                                <GetDoc color={'#A4A4A4'} id={'68a544ecb248309ad534a57a'} title={'Baixa aqui a "LISTA MODELO EXCEL" de medicamentos a importar'} />

                                <br />
                                <br />
                                <InputDocUpload
                                    onFileSelect={HandleChangeFile}
                                    inputName={'listaItems'}
                                    inputDescription={'Carregar aquí a lista em EXCEL dos medicamentos a serem importados'}
                                    inputTitle={'Carregar lista em EXCEL dos medicamentos a serem importados'}
                                />
                            </div>

                            <br />

                            <ButtonLeft title={lista ? 'Submeter lista' : 'Adicionar'} funcao={lista ? submiteAddILista : validate} disabled={!addItem && !lista} />
                            {/* <Link style={{ textDecoration: 'none', padding: 10 }} to={`/utente/solicitacao/importacao/${solicitacao._id}`}>CONCLUIDO</Link> */}
                        </Card>

                        <br />
                        <Card style={{ padding: 20 }}>
                            <HeaderGestorConfigs title={`ITENS ADICIONADOS : ${solicitacao?.productos.length}`} />
                            <ItensFactura itens={solicitacao?.productos} solicitacao={solicitacao} />
                        </Card>

                        <DialogActions>
                            <Link style={{ textDecoration: 'none', padding: 10 }} to={`/utente/solicitacao/importacao/${solicitacao._id}`}>Cliqua aqui para concluir </Link>
                        </DialogActions>
                        <br />
                    </div>
                    :
                    <Loading />
                }
            </Container>
        </div>
    );
}
